import { Model } from "@vuex-orm/core";
import BizReviewHistory from "./BizReviewHistory";

export default class BizReviewType extends Model {
  static entity = "bizReviewTypes";

  static fields() {
    return {
      id: this.attr(),
      // accountId: this.attr(),
      // isDirty: this.boolean(false),
      name: this.string(),
      code: this.string(),
      configField: this.string(),
      bizReviewHistory: this.hasMany(BizReviewHistory, "bizReviewTypeId")
    };
  }

  static mutators() {
    return {};
  }
}
